import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { PAGE_NAME } from "reducers/menu";
import { useLocation } from "react-router-dom";
import { AI_getUserData } from "APIs/user";
import { useInstance } from "easy-redux-http-call";
import { useParams } from "react-router-dom/dist/index";

// for loading
export const useIntersection = ({ root = null, rootMargin, threshold = 0 }) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);
  const observer = useRef(
    new window.IntersectionObserver(([entry]) => updateEntry(entry), {
      root,
      rootMargin,
      threshold,
    })
  );
  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver.disconnect();
    if (node) currentObserver.observe(node);
    return () => currentObserver.disconnect();
  }, [node]);
  return [setNode, entry];
};

// store page name on redux state
export const useStorePageName = ({ data }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: PAGE_NAME,
      payload: data,
    });
  }, []);
};

export const useAuthenticate = () => {
  let { employeeid } = useParams();
  const getUserData = useInstance(AI_getUserData);
  const checkInProbation = getUserData?.data?.user?.in_probation;
  const tempUrl = `employee/${employeeid}/details`;
  const u = getUserData?.data?.user;
  const sub = u?.is_submit;
  const authenticatRoutes = {
    // ── existing ──────────────────────────────────────────────────────────────
    departments:        u?.is_access_to_department  && sub,
    "emplyoee/add":     u?.is_access_to_employee    && sub,
    [tempUrl]:          u?.is_access_to_employee    && sub,
    emplyoee:           u?.is_access_to_employee    && sub,
    roles:              u?.is_access_to_roles        && sub,
    project:            u?.is_access_to_project     && sub,
    "bank-details":     u?.only_employee_view        && sub,
    document:           u?.only_employee_view        && sub,
    work:               u?.only_employee_view        && sub,
    education:          u?.only_employee_view        && sub,
    address:            u?.only_employee_view        && sub,
    nominee:            u?.only_employee_view        && sub,
    "personal-details": u?.only_employee_view        && sub,
    projects:           u?.only_employee_view        && sub,
    leave:              !checkInProbation && u?.only_employee_view && sub,

    // ── admin / role-gated pages ──────────────────────────────────────────────
    "admin_handover_dashboard":  u?.is_admin                                          && sub,
    "get-all-incident":          (u?.is_admin_role || u?.is_access_to_incident || u?.is_admin) && sub,
    "technical-employee":        u?.is_techinal_employee_view                         && sub,
    assets:                      u?.is_admin_role                                     && sub,
    "leave-request-details":     u?.is_access_to_leaveDetails                        && sub,
    "leave-calendar":            (u?.is_access_to_leaveDetails || u?.is_access_to_employee || u?.is_access_to_leaveCalendar) && sub,
    "live-attendance":           (u?.is_admin || u?.role_name === "HR Manager")       && sub,
    "missed-punch-history":      (u?.is_admin || u?.role_name === "HR Manager")       && sub,
    "punch-analysis":            (u?.is_admin || u?.role_name === "HR Manager")       && sub,
    "time-log-viewer":           u?.is_admin_role                                     && sub,
    setting:                     u?.is_access_to_settings                             && sub,
    announcements:               u?.is_access_to_settings                             && sub,
    party:                       u?.is_access_to_settings                             && sub,
    feedback:                    u?.is_access_to_settings                             && sub,
    "leave-balance":             u?.is_access_to_employee                             && sub,
    "excel-leave-balance":       u?.is_access_to_employee                             && sub,
    "excel-leave-upload":        u?.is_access_to_employee                             && sub,
    "excel-leave-discrepancies": u?.is_access_to_employee                             && sub,
    interview:                   u?.is_access_to_interview                            && sub,
    "user-logs":                 u?.is_admin_role                                     && sub,
  };
  const location = useLocation();
  const path = location.pathname.replace("/", "");
  return authenticatRoutes[path];
};
